'use client';

import { InfoTile } from '../info-tile/info-tile';

import { InfoTileListProps } from './info-tile-list-model';
import styles from './info-tile-list.module.scss';

export const InfoTileList = ({ items, sectionId }: InfoTileListProps) => {
  return (
    <div className={styles.infoTileList} id={sectionId} role="list">
      {items.map((item, i) => (
        <InfoTile
          key={i + item.heading}
          heading={item.heading}
          body={item.body}
          btnText={item.btnText}
          btnAltText={item.btnAltText}
          btnClickHandler={item.btnClickHandler}
          background={item.background}
          variant={item.variant}
          position={item.position}
          graphicUrl={item.graphicUrl}
          iconName={item.iconName}
        />
      ))}
    </div>
  );
};
